import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

import { Link } from "react-router-dom";
import NewsService, { newsImageSrc } from "../services/news.service";
import { useTranslation } from "react-i18next";
import Spinner from "./Spinner";

const News = () => {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [filters, setFilters] = useState({});

  // Debounce title typing; dates apply immediately.
  useEffect(() => {
    const id = setTimeout(() => {
      const f = {};
      if (q.trim()) f.q = q.trim();
      if (from) f.from = from;
      if (to) f.to = to;
      setFilters(f);
    }, 300);
    return () => clearTimeout(id);
  }, [q, from, to]);

  const hasFilters = Object.keys(filters).length > 0;
  const reset = () => { setQ(""); setFrom(""); setTo(""); };

  useEffect(() => {
    setLoading(true);
    NewsService.getAll(filters)
      .then((res) => setNews(res.data || []))
      .catch((err) =>
        toast.error(
          (err.response && err.response.data && err.response.data.message) ||
            err.message
        )
      )
      .finally(() => setLoading(false));
  }, [filters]);

  return (
    <div className="container my-4">
      <h3 className="mb-4">{t("news.title")}</h3>

      <form className="row g-2 align-items-end mb-4" onSubmit={(e) => e.preventDefault()}>
        <div className="col-md-5">
          <label className="form-label small mb-1" htmlFor="news-q">{t("news.searchTitle")}</label>
          <input id="news-q" type="search" className="form-control"
            placeholder={t("news.searchPlaceholder")}
            value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
        <div className="col-6 col-md-2">
          <label className="form-label small mb-1" htmlFor="news-from">{t("news.fromDate")}</label>
          <input id="news-from" type="date" className="form-control"
            value={from} max={to || undefined} onChange={(e) => setFrom(e.target.value)} />
        </div>
        <div className="col-6 col-md-2">
          <label className="form-label small mb-1" htmlFor="news-to">{t("news.toDate")}</label>
          <input id="news-to" type="date" className="form-control"
            value={to} min={from || undefined} onChange={(e) => setTo(e.target.value)} />
        </div>
        <div className="col-md-3">
          <button type="button" className="btn btn-outline-secondary w-100"
            onClick={reset} disabled={!q && !from && !to}>
            {t("news.clearFilters")}
          </button>
        </div>
      </form>

      {loading ? (
        <Spinner />
      ) : news.length === 0 ? (
        <p className="text-muted">{hasFilters ? t("news.noResults") : t("news.empty")}</p>
      ) : (
        <div className="row g-4">
          {news.map((n) => (
            <div className="col-md-6 col-lg-4" key={n.id}>
              <div className="card h-100 shadow-sm">
                {n.image && (
                  <img
                    src={newsImageSrc(n.image)}
                    className="card-img-top object-fit-cover"
                    style={{ height: 180 }}
                    alt={n.title}
                  />
                )}
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">{n.title}</h5>
                  <p className="text-muted small mb-2">
                    {new Date(n.createdAt).toLocaleDateString()}
                  </p>
                  <p className="card-text flex-grow-1">
                    {n.summary ||
                      (n.content || "").replace(/<[^>]+>/g, "").slice(0, 120)}
                    …
                  </p>
                  <Link
                    to={`/news/${n.id}`}
                    className="btn btn-sm btn-outline-primary mt-auto align-self-start"
                  >
                    {t("news.readMore")}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default News;
